<template>
  <v-data-table
    :headers="headers"
    :items="access_log"
    :items-per-page="-1"
    :loading="is_loading"
    hide-default-footer
  >
    <template v-slot:item.created_at="{ item }">
      {{ formateDate(new Date(item.created_at)) }}
    </template>
    <template v-slot:item.access_granted="{ item }">
      <v-icon
        v-if="item.access_granted"
        color="success"
      >
        mdi-check-circle
      </v-icon>
      <v-icon
        v-else
        color="error"
      >
        mdi-close-circle
      </v-icon>
    </template>
    <template v-slot:footer>
      <v-divider></v-divider>
      <v-btn
        v-if="$store.state.kentix.access_log !== null && $store.state.kentix.access_log.length !== 0"
        class="primary ma-2"
        @click="entries_amount = entries_amount + 50; get_entries()"
        :loading="entries_amount !== $store.state.kentix.access_log.length"
      >
        Mehr Einträge laden
      </v-btn>
      <span
        v-if="$store.state.kentix.access_log !== null"
      >
        Geladene Einträge: {{ $store.state.kentix.access_log.length }}
      </span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "ls-logbook",
  data: () => ({
    entries_amount: 50,
    headers: [
      { text: 'Zeit', value: 'created_at'},
      { text: 'Tür', value: 'door', sortable: false },
      { text: 'Benutzer', value: 'user' },
      { text: 'Zutritt', value: 'access_granted' },
      { text: 'Detail', value: 'detail' }
    ]
  }),
  methods: {
    formateDate(date){
      return date.toLocaleDateString() + ", " + date.toLocaleTimeString('de-DE')
    },
    get_entries(){
      this.$store.dispatch("update", { "payload_type": 'GET', "context": "/kentix/log/" + this.entries_amount})
    }
  },
  computed: {
    is_loading(){
      return this.$store.state.kentix.access_log == null || this.$store.state.kentix.devices == null || this.$store.state.kentix.levelprofiles == null
    },
    access_log(){
      let searchQuery = this.$store.state.general.global_search
      return this.is_loading ? [] : this.$store.state.kentix.access_log.filter((entry) => entry.door.toLowerCase().includes(searchQuery) || entry.user.toLowerCase().includes(searchQuery))
    }
  },
  mounted() {
    this.get_entries()
  }
};
</script>

<style scoped>

</style>
